module.exports = __webpack_public_path__ + "img/16.53a61be0.png";